import { render, staticRenderFns } from "./AssetTransaction.vue?vue&type=template&id=09808efe&scoped=true"
import script from "./AssetTransaction.vue?vue&type=script&lang=js"
export * from "./AssetTransaction.vue?vue&type=script&lang=js"
import style0 from "./AssetTransaction.vue?vue&type=style&index=0&id=09808efe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09808efe",
  null
  
)

export default component.exports